export enum LeaseCreateMethod {
  NEW_LEASE = 'NEW_LEASE',
  NEW_LEASE_FOR_RETAILER = 'NEW_LEASE_FOR_RETAILER',
  EDIT_LEASE = 'EDIT_LEASE'
}
